import Payment from 'payment';
import { createNumberMask } from 'text-mask-addons/dist/textMaskAddons';

function clearNumber(value: string = '') {
  return value.replace(/\D+/g, '');
}

export function formatCreditCardNumber(value: string) {
  if (!value) {
    return value;
  }

  const issuer = Payment.fns.cardType(value);
  const clearValue = clearNumber(value);
  let nextValue;

  switch (issuer) {
    case 'amex':
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10,
      )} ${clearValue.slice(10, 15)}`;
      break;
    case 'dinersclub':
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10,
      )} ${clearValue.slice(10, 14)}`;
      break;
    default:
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        8,
      )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
      break;
  }

  return nextValue.trim();
}

export function formatCVC(value: string, allValues: any = {}) {
  const clearValue = clearNumber(value);
  let maxLength = 4;

  if (allValues.number) {
    const issuer = Payment.fns.cardType(allValues.number);
    maxLength = issuer === 'amex' ? 4 : 3;
  }

  return clearValue.slice(0, maxLength);
}

export function formatExpirationDate(value: string) {
  const clearValue = clearNumber(value);

  if (clearValue.length >= 3) {
    return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
  }

  return clearValue;
}

export function formatFormData(data: { [key: string]: string | number }) {
  return Object.keys(data).map(d => `${d}: ${data[d]}`);
}

export const currencyMask = createNumberMask({
  prefix: '$',
  suffix: '',
  allowDecimal: true
});

export const numberFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
});


//create a  function that accepts date in year-month-day format and subtracts the current date from the date passed in and returns the number of days
export function getDaysLeft(date: string) {
  const currentDate = new Date();
  const inputDate = new Date(date);
  const diff = inputDate.getTime() - currentDate.getTime();
  const daysLeft = Math.ceil(diff / (1000 * 3600 * 24));
  return daysLeft;
}



export function datetoObject(date: string | null = null, isdueDate: boolean = false) {


  let strToDate = null;
  //because dash(-) reduces a day by one: see https://www.sunzala.com/why-the-javascript-date-is-one-day-off
  if (date != null) {
    date = date.replace(/-/g, "/");
    strToDate = new Date(date);
  }
  else {
    strToDate = new Date();
  }


  return {
    year: strToDate.getFullYear(),
    month: strToDate.getMonth() + 1,
    day: strToDate.getDate()
  }




}

// Convert YYYYMMDD format to YYYY-MM-DD for date parsing
export function formatDrewDate(dtdue: string): string {
  if (!dtdue || dtdue.length !== 8) return dtdue;
  return `${dtdue.slice(0, 4)}-${dtdue.slice(4, 6)}-${dtdue.slice(6, 8)}`;
}

// Get days left from Drew's date format (YYYYMMDD)
export function getDaysLeftFromDrew(dtdue: string): number {
  return getDaysLeft(formatDrewDate(dtdue));
}



